const t=/^0x[a-fA-F0-9]{40}$/;function n(n){return t.test(n)}export{n as isAddress};
